import { render, staticRenderFns } from "./PricingGrid.vue?vue&type=template&id=2ed9987c&scoped=true&"
import script from "./PricingGrid.vue?vue&type=script&lang=js&"
export * from "./PricingGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed9987c",
  null
  
)

export default component.exports